export default (sections, id, sectionName) => {
	return sections.map((section) => {
		if (section.id === id) {
			return {
				...section,
                instructions: section.instructions ? [...section.instructions] : [],
				sectionName
			};
		}
		return {...section};
	});
};
